import { render, staticRenderFns } from "./module-configuration.vue?vue&type=template&id=46dd6d6d&scoped=true&"
import script from "./module-configuration.vue?vue&type=script&lang=ts&"
export * from "./module-configuration.vue?vue&type=script&lang=ts&"
import style0 from "./module-configuration.vue?vue&type=style&index=0&id=46dd6d6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dd6d6d",
  null
  
)

export default component.exports